import { LocalOffer, Person } from "@material-ui/icons";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { stringifyVideoTimeWithLetters } from "../../../common/video/util/videoTimeStrings";
import PuiTypography from "../../../components/elements/PuiTypography";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import { PuiHighLight, Highlight } from "../../../components/widgets/PuiHighLight";
import { milliSecondToHr } from "../../../utils/ObjectUtils";
import { ShowResult } from "../Search";
import stylesPc from "./ContentSearch.module.css";
import stylesSp from "./ContentSearch_SP.module.css";

/**
|--------------------------------------------------
| サーチ画面詳細情報
|--------------------------------------------------
*/

interface ContentSearchDetailProps {
    content: ShowResult;
    ShowSearchModal: Dispatch<SetStateAction<boolean>>;
    changeOpenDrawerMenu?: Dispatch<SetStateAction<boolean>>;
}

export default function ContentSearchDetail({
    content,
    ShowSearchModal,
    changeOpenDrawerMenu,
}: ContentSearchDetailProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const history = useHistory();
    const [hitTitle, setHitTitle] = useState<string>("");
    //HitTitleの設定
    useEffect(() => {
        content.hitItem?.forEach((hit) => {
            if (hit.title === "title") {
                setHitTitle(hit.detail);
            }
        });
    }, [content]);

    //video再生画面に遷移
    const gotoVideo = (startMillis: number) => {
        history.push(`/video/${content.id}?time=${stringifyVideoTimeWithLetters(startMillis)}`);
        ShowSearchModal(false);
        if (changeOpenDrawerMenu) changeOpenDrawerMenu(false);
    };

    //slidestock画面に遷移
    const gotoSlideStock = (pageNumber: string) => {
        history.push(`/slidestock/${content.id}?pagenumber=${pageNumber}`);
        ShowSearchModal(false);
        if (changeOpenDrawerMenu) changeOpenDrawerMenu(false);
    };

    return (
        <>
            <div className={styles.thumbnaildiv}>
                {/* 画像表示エリア */}
                <Link
                    to={content.isVideo ? `/video/${content.id}` : `/slidestock/${content.id}`}
                    target="_blank"
                    className={styles.imgArea}
                >
                    <img
                        className={styles.thumbnail}
                        src={content.thumbnails}
                        alt=""
                        onError={(e) =>
                            (e.currentTarget.src = require("../../../assets/image/NoImage.jpg"))
                        }
                    />
                </Link>
                <div className={styles.textBody}>
                    {/* タイトル表示 */}
                    <div className={styles.title}>
                        <Link
                            to={
                                content.isVideo
                                    ? `/video/${content.id}`
                                    : `/slidestock/${content.id}`
                            }
                            target="_blank"
                        >
                            <div className={styles.thumbnailTitle} data-for="title" data-tip="">
                                <PuiTypography size={IsDevice("deesktop") ? 24 : 20}>
                                    {content.hitItem.find((hit) => hit.title === "title") ? (
                                        <>
                                            <PuiHighLight
                                                text={content.title}
                                                highlights={hitTitle}
                                            />
                                        </>
                                    ) : (
                                        content.title
                                    )}
                                </PuiTypography>
                            </div>
                        </Link>
                    </div>
                    {/* プレゼンター名表示 */}
                    <div className={styles.presenter}>
                        <div className={styles.personArea}>
                            <Person className={styles.personIcon} />
                            <PuiTypography size={17}>{content.presenterName}</PuiTypography>
                        </div>

                        {content.tagList && content.tagList.length > 0 && (
                            <div className={styles.tagArea}>
                                <LocalOffer className={styles.localOfferIcon} />
                                <div className={styles.tagList}>
                                    {content.tagList.map((tag) => (
                                        <div key={tag.id} className={styles.tag}>
                                            {tag.title}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        
                    </div>

                    {content.hitItem.map((hit, index) => (
                        hit.detail && hit.detail.length > 0 && (
                            <div key={index} className={styles.description}>
                                {/* 詳細表示エリア */}
                                {/* タイトルが’description'の場合、 */}
                                {hit.title === "description" && (
                                    <>
                                        {hit.position && (
                                            <PuiTypography size={IsDevice("deesktop") ? 16 : 14}>
                                                {hit.position}
                                            </PuiTypography>
                                        )}
                                        <PuiTypography size={IsDevice("deesktop") ? 16 : 14}>
                                            <Highlight highlights={hit.detail} />
                                        </PuiTypography>
                                    </>
                                )}
                                {/* タイトルが’content'の場合、 */}
                                {hit.title === "content" && (
                                    <div
                                        onClick={() => gotoSlideStock(hit.position)}
                                        className={styles.caption}
                                    >
                                        <PuiTypography size={IsDevice("deesktop") ? 16 : 14}>
                                            ページ番号：{hit.position}
                                        </PuiTypography>
                                        <br />
                                        <PuiTypography size={IsDevice("deesktop") ? 16 : 14}>
                                            <Highlight highlights={hit.detail} />
                                        </PuiTypography>
                                    </div>
                                )}
                                {/* タイトルが’content'の場合、 */}
                                {hit.title === "caption" && (
                                    <div
                                        onClick={() => gotoVideo(Number(hit.position))}
                                        className={styles.caption}
                                    >
                                        <PuiTypography size={IsDevice("deesktop") ? 16 : 14}>
                                            {milliSecondToHr(Number(hit.position))}
                                        </PuiTypography>
                                        <br />
                                        <PuiTypography size={IsDevice("deesktop") ? 16 : 14}>
                                            <Highlight highlights={hit.detail} />
                                        </PuiTypography>
                                    </div>
                                )}
                            </div>
                        )
                    ))}
                </div>
            </div>
        </>
    );
}
